import { memo, useContext, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { useGroupFeatures } from '@trinity/chat-components/containers/Chat/hooks.js';
import { config } from '@/config';

export const DocumentHelmet = memo(() => {
  const { query } = useContext(AppThemingContext);
  const features = useGroupFeatures();
  const description = `.`;
  const title = '';

  const ready = useMemo(() => {
    return !query.isLoading && query.isFetchedAfterMount;
  }, [
    query.isLoading,
    query.isFetchedAfterMount,
  ]);

  const head = useMemo(() => {
    if (!ready) {
      return {
        ogImage: '',
        shortcutIcon: '',
        title: '',
      };
    };

    const enabled = query.data?.enabled;
    const square = query.data?.logo?.square;
    const appTitle = query.data?.app?.title;

    const browserTabName = features.browserTabName;

    let title = enabled && appTitle ? appTitle : 'InsightsEDGE';

    if (browserTabName) {
      title = browserTabName;
    };
    return {
      ogImage: enabled && square ? square : `${window.location.origin}/media/favicon-192x192.png`,
      shortcutIcon: enabled && square ? square : '/favicon.ico',
      title,
    };
  }, [features, query.data?.app?.title, query.data?.enabled, query.data?.logo?.square, ready]);

  return (
    <Helmet
      defaultTitle={title}
      titleTemplate={`%s`}>
      <meta name="robots" content="noindex" />
      <title>{head.title}</title>
      <link
        rel="shortcut icon"
        href={head.shortcutIcon}
        type="image/x-icon" />
      <link
        rel="icon"
        href={head.shortcutIcon} />
      <link
        rel="canonical"
        href={`${config().FRONT_BASE_URL}/`} />
      <meta
        name='description'
        content={description} />
      <meta
        name='og:description'
        content={description} />
      <meta
        name="og:image"
        content={head.ogImage} />
      <meta
        name="og:site name"
        content={head.title} />
    </Helmet>
  );
});